import { isLiveLocationLabel } from '../../location/locationRules';
import { POLL_MESSAGE_TYPE } from '../../poll/pollRules';
import { getPollMessagePreview } from '../../poll/pollText';
import {
    getAudioPreview,
    getContactPreview,
    getDocumentPreview,
    getLocationPreview,
    getPhotoPreview,
    getVideoPreview,
} from '../../recentChat/previewText';

/**
 * One line of text standing in for a message in a list.
 *
 * Reuses the preview helpers the chat list uses, so a photo or a voice note reads the same
 * wording in the pinned, starred, kept and scheduled lists instead of drifting apart.
 *
 * @param {object} message A message with its msgBody.
 * @returns {string} The summary to show on the row.
 */
export const getEntrySummary = message => {
    const { msgBody = {} } = message || {};
    const { media = {}, message_type: messageType } = msgBody;

    // A caption replaces the type label entirely, matching the chat list.
    if (media.caption) return media.caption;

    switch (messageType) {
        case 'image':
            return getPhotoPreview(media);
        case 'video':
            return getVideoPreview(media);
        case 'audio':
            return getAudioPreview(media);
        case 'file':
            return getDocumentPreview(media);
        case 'contact':
            return getContactPreview(msgBody.contact || {});
        case 'location':
            return getLocationPreview(msgBody.location || {}, isLiveLocationLabel(msgBody, message.metaData));
        // A poll carries an empty message; its question is the summary.
        case POLL_MESSAGE_TYPE:
            return getPollMessagePreview({ poll: msgBody.poll, publisherId: message.publisherId });
        default:
            return msgBody.message || '';
    }
};
